import classNames from "classnames";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import advanced from "dayjs/plugin/advancedFormat";
import { ImageIcon } from "components/molecules/ImageIcon";
import { Button, Typography } from "components/atoms";
import { useScreenSize } from "hooks";
import { MOBILE_WIDTH, TAB_WIDTH } from "utils/constants";
import { CalenderIcon } from "components/atoms/Icon";
import image from "assets/Ellipse 155.png";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { SelfPacedConditionalBtns } from "./SelfPacedConditionalBtns";
import { CalendarEvent, google, ics, outlook, yahoo } from "calendar-link";
import { formatToLocalDate } from "utils/functions/formatToLocalDate";
import { getTimeZone } from "utils/functions/getTimeZone";
import { AddToExternalCalenderList } from "../TIle/AddToExternalCalenderList";
import "./index.scss";

interface IProps {
  title: string;
  borderColor: string;
  isTabShow: boolean;
  btnType: string;
  segmentId: number;
  theme: "light" | "dark";
  showOnlyTitle?: boolean;
  groups?: any;
  styles?: string;
  startTime?: string;
  endTime?: string;
  timeSpan?: string;
  profileImage?: string;
  messageIcon?: boolean;
  name?: string;
  btnLabel?: string;
  isInstructorImageOnTop?: boolean;
  email?: string;
  index?: number;
  segmentObj?: any;
}

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advanced);
const guessedTimezone = dayjs.tz.guess();

export const SelfPacedTile = ({
  borderColor = "black",
  styles,
  title = "Test 4",
  startTime = "Saturday. August 12",
  endTime = "10:00 AM - 5:00 PM EDT",
  timeSpan = "",
  profileImage,
  groups,
  messageIcon,
  btnLabel,
  name,
  theme,
  btnType,
  segmentId,
  showOnlyTitle,
  isTabShow,
  isInstructorImageOnTop,
  email,
  index,
  segmentObj,
}: IProps) => {
  const screen = useScreenSize();
  const [isExternalCalenderListShow, setIsExternalCalenderListShow] =
    useState(false);
  const [googleLink, setGoogleLink] = useState("");
  const [yahooLink, setYahooLink] = useState("");
  const [outLookLink, setOutLookLink] = useState("");
  const [icsLink, setIcsLink] = useState("");

  const calendarRef = useRef<HTMLDivElement>(null);

  const handleAddToExternalCalender = (
    title: string,
    startTime: string,
    endTime: string
  ) => {
    let startTimeString = `${formatToLocalDate(startTime, "YYYY-MM-DD HH:mm:ss")} ${getTimeZone(startTime)}`;
    let endTimeString = `${formatToLocalDate(endTime, "YYYY-MM-DD HH:mm:ss")} ${getTimeZone(endTime)}`;

    const event: CalendarEvent = {
      title: title,
      start: startTimeString,
      end: endTimeString,
      description: "Online Classroom",
    };

    setGoogleLink(google(event));
    setOutLookLink(outlook(event));
    setYahooLink(yahoo(event));
    setIcsLink(ics(event));
    setIsExternalCalenderListShow((prev) => !prev);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      calendarRef.current &&
      !calendarRef.current.contains(event.target as Node)
    ) {
      setIsExternalCalenderListShow(false);
    }
  };

  const formatDate = (dateInput: string): string => {
    let date = dayjs.utc(dateInput).local().format("dddd, MMMM DD");
    return `${date}`;
  };

  const formatTimeRange = (dateTime: string): string => {
    let localTime = dayjs(dateTime).isValid()
      ? dayjs.utc(dateTime).local().format("hh:mm A")
      : dateTime;
    return localTime;
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="self-paced-tile-container">
      {
        <div
          className={classNames(
            "self-paced-tile-wrapper",
            `default-border-${borderColor}`
          )}
        >
          <div className={classNames("tile", { [`${styles}`]: styles })}>
            {screen.width > MOBILE_WIDTH && screen.width <= TAB_WIDTH ? (
              <>
                <div className="tab-layout-detail-card">
                  <div className={classNames("content-section")}>
                    <div className="content-1">
                      <Typography label={title} variant="h5Bold" />
                    </div>
                    {showOnlyTitle ? null : (
                      <>
                        {screen.width < MOBILE_WIDTH ? (
                          <div className={classNames("image-section")}>
                            <ImageIcon
                              label="default label"
                              icon={messageIcon}
                              email={email}
                              image={image}
                              styles="img-text-icon-tile"
                              theme={theme}
                            />
                          </div>
                        ) : null}
                        <div className="content-2">
                          <div>
                            <Typography
                              label={formatDate(startTime)}
                              variant="h7Med"
                            />
                          </div>

                          <div className="content-2-1">
                            <Typography
                              label={`${formatTimeRange(startTime)} - ${formatTimeRange(endTime)} ${dayjs()
                                .tz(guessedTimezone)
                                .format("z")}`}
                              variant="h8Book"
                              spanStyle="suggested-date-custom-style"
                            />
                            {screen.width < MOBILE_WIDTH ? (
                              <CalenderIcon
                                color={theme === "light" ? "black" : "white"}
                              />
                            ) : null}
                          </div>
                        </div>
                        {screen.width > MOBILE_WIDTH ? (
                          <div className="content-3" ref={calendarRef}>
                            <Button
                              label="Add To External Calendar"
                              icon={true}
                              type="icon-text"
                              onClick={() =>
                                handleAddToExternalCalender(
                                  title,
                                  startTime,
                                  endTime
                                )
                              }
                            />
                            {isExternalCalenderListShow ? (
                              <AddToExternalCalenderList
                                icsLink={icsLink}
                                googleLink={googleLink}
                                yahooLink={yahooLink}
                                outLookLink={outLookLink}
                                setIsExternalCalenderListShow={
                                  setIsExternalCalenderListShow
                                }
                              />
                            ) : null}
                          </div>
                        ) : null}{" "}
                      </>
                    )}
                  </div>
                  {showOnlyTitle ? null : (
                    <div
                      className={classNames(
                        "tab-layout-image-btn-section",
                        !profileImage && "non-image-btn"
                      )}
                    >
                      {profileImage ? (
                        <div className={classNames("image-section")}>
                          <ImageIcon
                            label={name ? name : "default name"}
                            icon={messageIcon}
                            email={email}
                            image={profileImage}
                            styles="img-text-icon-tile"
                            theme={theme}
                          />
                        </div>
                      ) : null}
                      <div className={classNames("button-section")}>
                        <div className="btn-wrapper">
                          <SelfPacedConditionalBtns
                            segment={segmentObj}
                            index={index}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                <div className={classNames("content-section")}>
                  <div className="content-1">
                    <Typography label={title} variant="h5Bold" />
                  </div>
                  {showOnlyTitle ? null : (
                    <>
                      <div className="content-2">
                        <div>
                          <Typography
                            label={formatDate(startTime)}
                            variant="h7Med"
                          />
                        </div>

                        <div className="content-2-1">
                          <Typography
                            label={`${formatTimeRange(startTime)} - ${formatTimeRange(endTime)} ${dayjs()
                              .tz(guessedTimezone)
                              .format("z")}`}
                            variant="h8Book"
                            spanStyle="suggested-date-custom-style"
                          />
                          {screen.width < MOBILE_WIDTH ? (
                            <div
                              className="mobile-calendar-list-wrapper"
                              ref={calendarRef}
                            >
                              <CalenderIcon
                                color={theme === "light" ? "black" : "white"}
                                onClick={() =>
                                  handleAddToExternalCalender(
                                    title,
                                    startTime,
                                    endTime
                                  )
                                }
                              />
                              {isExternalCalenderListShow ? (
                                <AddToExternalCalenderList
                                  icsLink={icsLink}
                                  googleLink={googleLink}
                                  yahooLink={yahooLink}
                                  outLookLink={outLookLink}
                                  setIsExternalCalenderListShow={
                                    setIsExternalCalenderListShow
                                  }
                                />
                              ) : null}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {profileImage && screen.width < MOBILE_WIDTH ? (
                        <div
                          className={classNames({
                            "image-section": true,
                            "align-top": isInstructorImageOnTop,
                          })}
                        >
                          <ImageIcon
                            label={name ? name : "default name"}
                            icon={messageIcon}
                            email={email}
                            image={profileImage}
                            styles="img-text-icon-tile"
                            theme={theme}
                          />
                        </div>
                      ) : null}
                      {screen.width > MOBILE_WIDTH ? (
                        <div className="content-3" ref={calendarRef}>
                          <Button
                            label="Add To External Calendar"
                            icon={true}
                            type="icon-text"
                            onClick={() =>
                              handleAddToExternalCalender(
                                title,
                                startTime,
                                endTime
                              )
                            }
                          />
                          {isExternalCalenderListShow ? (
                            <AddToExternalCalenderList
                              icsLink={icsLink}
                              googleLink={googleLink}
                              yahooLink={yahooLink}
                              outLookLink={outLookLink}
                              setIsExternalCalenderListShow={
                                setIsExternalCalenderListShow
                              }
                            />
                          ) : null}
                        </div>
                      ) : null}
                    </>
                  )}
                </div>
                {showOnlyTitle ? null : (
                  <>
                    {profileImage && screen.width > MOBILE_WIDTH ? (
                      <div
                        className={classNames({
                          "image-section": true,
                          "align-top": isInstructorImageOnTop,
                        })}
                      >
                        <ImageIcon
                          label={name ? name : "default name"}
                          icon={messageIcon}
                          email={email}
                          image={profileImage}
                          styles="img-text-icon-tile"
                          theme={theme}
                        />
                      </div>
                    ) : null}
                    <div className={classNames("button-section")}>
                      <div className="btn-wrapper">
                        <SelfPacedConditionalBtns
                          segment={segmentObj}
                          index={index}
                        />
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      }
    </div>
  );
};
